import { LegalPage } from "@/pages/legal/LegalPage";
import { site } from "@/config/site";

// Modèle à faire relire par un conseil juridique avant publication.
const sections = [
  {
    title: "Responsable du traitement",
    content: [
      `Le responsable du traitement des données à caractère personnel collectées via le site ${site.domain} est <strong>${site.name}</strong>, ${site.legalFormShort}, ${site.address.full}, RCS ${site.rcsCity} ${site.rcsNumber}. Contact : <a href="${site.emailHref}">${site.email}</a>.`,
      "La présente politique est établie conformément au Règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et à la loi n° 78-17 du 6 janvier 1978 modifiée dite « Informatique et Libertés ».",
    ],
  },
  {
    title: "Données collectées",
    content: [
      "<strong>Via les formulaires</strong> (devis et contact) : type de demande, service concerné, société, SIREN/SIRET, nom et prénom, fonction, email professionnel, téléphone, pays, produits concernés, quantités, délai, budget indicatif, description du besoin, sujet et message, ainsi que votre consentement et sa date.",
      "<strong>Via la navigation</strong> : adresse IP, données de connexion, type de navigateur, pages visitées — uniquement si des outils de mesure d'audience sont activés (ce qui n'est pas le cas à ce jour) ou dans le cadre des journaux techniques de sécurité de l'hébergeur.",
    ],
  },
  {
    title: "Finalités et bases légales",
    content: [
      { ul: [
        "<strong>(a) Traitement des demandes de devis et de contact</strong> : exécution de mesures précontractuelles prises à votre demande et intérêt légitime à répondre aux sollicitations.",
        "<strong>(b) Gestion de la relation commerciale et facturation</strong> : exécution du contrat et respect d'obligations légales.",
        "<strong>(c) Prospection commerciale</strong> : consentement (case facultative du formulaire) ou intérêt légitime s'agissant de professionnels, avec possibilité de vous y opposer ou de retirer votre consentement à tout moment.",
        "<strong>(d) Sécurité du site et prévention de la fraude</strong> (anti-spam, limitation des envois) : intérêt légitime.",
        "<strong>(e) Respect des obligations légales et comptables.</strong>",
      ] },
    ],
  },
  {
    title: "Durées de conservation",
    content: [
      { ul: [
        "Demandes de devis ou de contact non abouties : 3 ans à compter du dernier contact ;",
        "Clients : durée de la relation contractuelle, augmentée de la durée légale de conservation des documents comptables (10 ans) ;",
        "Données de prospection : 3 ans à compter du dernier contact ;",
        "Cookies et traceurs : 13 mois maximum ; mémorisation du choix de consentement : 6 mois ;",
        "Journaux de connexion : 12 mois maximum.",
      ] },
    ],
  },
  {
    title: "Destinataires et transferts",
    content: [
      `Les données sont destinées au Président et aux personnes habilitées de ${site.name}, ainsi qu'aux sous-traitants strictement nécessaires : hébergeur (${site.host.name}), prestataire d'envoi d'emails transactionnels (Resend, Inc.) et, le cas échéant, prestataire de mesure d'audience. Liste des sous-traitants à la date de mise à jour : ${site.host.name} (hébergement) ; Resend, Inc. (envoi des emails de notification et d'accusé de réception).`,
      `Aucun transfert de données hors de l'Union européenne n'est réalisé, sauf mention contraire. L'hébergement du site auprès de ${site.host.name} (États-Unis) peut toutefois impliquer un transfert hors UE ; celui-ci est encadré par les clauses contractuelles types de la Commission européenne et/ou le Data Privacy Framework UE–États-Unis.`,
      "Les données ne sont en aucun cas cédées, louées ou vendues à des tiers.",
    ],
  },
  {
    title: "Vos droits",
    content: [
      "Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation du traitement, d'opposition, à la portabilité de vos données, ainsi que du droit de retirer votre consentement à tout moment et de définir des directives relatives au sort de vos données après votre décès.",
      `Ces droits s'exercent par email à <a href="${site.emailHref}">${site.email}</a> ou par courrier à ${site.name}, ${site.address.full}. Une réponse vous sera adressée dans un délai d'un mois, prolongeable de deux mois en cas de demande complexe. Un justificatif d'identité pourra être demandé en cas de doute raisonnable.`,
      `Vous disposez également du droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">cnil.fr</a> — 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07.`,
    ],
  },
  {
    title: "Cookies et traceurs",
    content: [
      "<strong>Cookies strictement nécessaires</strong> : fonctionnement du site, sécurité et mémorisation de votre choix de consentement (durée : 6 mois). Ils ne requièrent pas de consentement.",
      "<strong>Cookies non essentiels</strong> : mesure d'audience et, éventuellement, marketing. Aucun cookie non essentiel n'est déposé avant votre consentement. À ce jour, aucun outil de mesure d'audience n'est activé sur le site.",
      "Conformément aux recommandations de la CNIL, le bandeau de consentement propose des boutons « Accepter », « Refuser » et « Personnaliser » d'égale visibilité, sans case pré-cochée. Vous pouvez retirer ou modifier votre consentement à tout moment via le lien « Gérer mes cookies » en pied de page.",
    ],
  },
  {
    title: "Sécurité",
    content: [`${site.name} met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données : chiffrement des échanges (HTTPS), contrôle des accès, dispositifs anti-spam, sauvegardes et sensibilisation des personnes habilitées.`],
  },
  { title: "Mineurs", content: ["Le site s'adresse exclusivement à des professionnels et n'est pas destiné aux mineurs. Aucune donnée relative à des mineurs n'est sciemment collectée."] },
  { title: "Modification de la politique", content: [`La présente politique peut être mise à jour à tout moment, notamment pour tenir compte des évolutions légales ou techniques. La date de dernière mise à jour est affichée en haut de la page (${site.legalUpdated}).`] },
  {
    title: "Contact",
    content: [`Pour toute question relative à la protection de vos données personnelles : ${site.name} — ${site.address.full} — <a href="${site.emailHref}">${site.email}</a> — <a href="${site.phoneHref}">${site.phone}</a>.`],
  },
];

export default function Confidentialite() {
  return (
    <LegalPage
      title="Politique de confidentialité (RGPD) | MINES DE PARIS"
      description="Politique de confidentialité de MINES DE PARIS : données collectées, finalités, bases légales, durées de conservation, destinataires, droits des personnes, cookies et sécurité, conformément au RGPD."
      path="/politique-de-confidentialite"
      crumb="Politique de confidentialité"
      intro="Comment MINES DE PARIS collecte, utilise et protège vos données personnelles, conformément au RGPD et à la loi Informatique et Libertés."
      sections={sections}
    />
  );
}
